import { ReactComponent as ErrorIcon } from '../../assets/images/svg/error.svg';
import { ReactComponent as BGLeft } from '../../assets/images/svg/left-side-background.svg';
import { ReactComponent as BGRight } from '../../assets/images/svg/right-side-background.svg';
import { useNavigate } from 'react-router-dom';
import { NotFoundContainer } from './style';
import { useIntl } from 'react-intl';

const Error = () => {
  const { formatMessage } = useIntl();

  const navigate = useNavigate();
  return (
    <NotFoundContainer>
      <div className="img-container">
        <BGRight />
        <ErrorIcon />
        <BGLeft />
      </div>
      <label>{formatMessage({ id: 'titleError' })}</label>
      <span>{formatMessage({ id: 'descError' })}</span>
      <button onClick={() => navigate('/appointments')}>
        {formatMessage({ id: 'btn404' })}
      </button>
    </NotFoundContainer>
  );
};

export default Error;
